<template>
  <div ref="desktopNavRef">
    <nav class="sr-only ellevio-skip-links text-newColors-gray-base bg-newColors-green-primaryA focus-within:not-sr-only z-[999991]">
      <ul class="flex flex-nowrap gap-6">
        <li>
          <a href="#main-menu" class="text-lg rounded-sm focus:outline-white-alt">{{ navigationData.translations?.skipLinks?.toMenu }}</a>
        </li>
        <li>
          <a href="#main-content" class="text-lg rounded-sm focus:outline-white-alt">{{ navigationData.translations?.skipLinks?.toContent }}</a>
        </li>
      </ul>
    </nav>

    <div class="flex flex-wrap ellevio-desktop-nav container-large">
      <div class="flex w-full">
        <!--<ellevio-web-desktop-nav-upper :navigationData="navigationData.secondaryMenu" :ariaLabelUpperNav="navigationData.ariaLabels.upperNav" />-->
        <ellevio-web-desktop-nav-upper :navigationData="navigationData" :otherLanguage="navigationData.otherLanguage" :logoLink="logoLink" :megaMenuOpen="megaMenuOpen" />
      </div>
      <div class="flex w-full">
        <!--<ellevio-web-desktop-nav-lower @toggleMegaMenu="handleToggleMegaMenu" :headerHeight="headerHeight" :navigationData="navigationData" :activeMenuItem="activeMenuItem" :ariaLabelLowerNav="navigationData.ariaLabels.lowerNav" />-->
        <ellevio-web-desktop-nav-lower
          @toggleMegaMenu="handleToggleMegaMenu"
          :searchApiUrl="searchApiUrl"
          :searchPageUrl="searchPageUrl"
          :headerHeight="headerHeight"
          :navigationData="navigationData"
          :translations="navigationData.translations"
          :searchNoHitsContent="searchNoHitsContent"
          @megaMenuIsOpen="setPropsForMegaMenuOpen"
          :activeMenuItem="activeMenuItem"
          :scrollbarWidth="scrollbarWidth" />
      </div>
    </div>
  </div>
</template>

<script>
import EllevioWebDesktopNavLower from './DesktopNavLower.vue'
import EllevioWebDesktopNavUpper from './DesktopNavUpper.vue'

export default {
  name: 'ellevio-web-desktop-nav',
  components: {
    EllevioWebDesktopNavLower,
    EllevioWebDesktopNavUpper
  },
  emits: ['toggleMegaMenu'],
  props: {
    searchNoHitsContent: {
      type: String,
      default: ''
    },
    headerHeight: {
      type: Number,
      default: 0
    },
    logoLink: {
      type: String,
      default: '/'
    },
    navigationData: {
      type: Object,
      default: () => {}
    },
    otherLanguage: {
      type: Object,
      default: () => {}
    },
    searchApiUrl: {
      type: String,
      default: ''
    },
    searchPageUrl: {
      type: String,
      default: ''
    },
    scrollbarWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeMenuItem: '',
      megaMenuOpen: false
    }
  },
  computed: {},
  methods: {
    setPropsForMegaMenuOpen(isOpen) {
      this.megaMenuOpen = isOpen
    },
    handleToggleMegaMenu(itemId) {
      this.activeMenuItem = itemId
      this.$emit('toggleMegaMenu', itemId.length > 0)
      this.toggleMegaMenuMargin()
    },
    toggleMegaMenuMargin() {
      if (this.$refs.desktopNavRef) {
        if (this.activeMenuItem === '') {
          this.$refs.desktopNavRef.style.marginRight = `0`
        } else {
          this.$refs.desktopNavRef.style.marginRight = `${this.scrollbarWidth}px`
        }
      }
    }
  }
}
</script>

<style scoped>
.ellevio-desktop-nav :deep(a:focus),
.ellevio-desktop-nav :deep(button:focus) {
  outline: 2px dotted #2c2827;
  outline-offset: 4px;
}

/* Menu buttons that open megamenu. With orange border hover effect */
.ellevio-desktop-nav :deep(.ellevio-mega-menu-item-button:not(.ellevio-mega-menu-login-link)::before) {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 0.25rem;
  @apply bg-newColors-orange-signatureA;
  transform: scaleX(0);
  transition: transform 250ms;
}
.ellevio-desktop-nav :deep(.ellevio-mega-menu-item-button:not(.ellevio-mega-menu-login-link):hover::before) {
  transform: scaleX(1);
}
.ellevio-desktop-nav :deep(.ellevio-mega-menu-item-button:not(.ellevio-mega-menu-login-link):active::before) {
  transform: scaleX(1);
}

/* Menu links with orange border hover effect */
.ellevio-desktop-nav:deep(.animated-menu-link) {
  position: relative;
}
.ellevio-desktop-nav:deep(.animated-menu-link:before) {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 0.25rem;
  @apply bg-newColors-orange-signatureA;
  transform: scaleX(0);
  transition: transform 250ms;
}
.ellevio-desktop-nav:deep(.animated-menu-link:hover::before) {
  @apply bg-orange-light;
}
.ellevio-desktop-nav:deep(.animated-menu-link:hover::before) {
  transform: scaleX(1);
}
.ellevio-desktop-nav:deep(.animated-menu-link.active::before) {
  transform: scaleX(1);
  @apply border-b-[0.125rem] border-solid border-newColors-orange-signatureA;
}

.ellevio-skip-links {
  position: absolute;
  transform: translateY(-100%) translateX(-50%);
  top: 0.25rem;
  left: 50%;
  transition: transform 0.3s;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}
.ellevio-skip-links:focus-within {
  transform: translateY(0%) translateX(-50%);
  outline: none !important;
  padding: 1rem 3rem !important;
}
</style>
